const Menu = {
  defaultProps: {
    disableScrollLock: true,
  },
  styleOverrides: {
    list: ({ theme }) => ({
      gap: 4,
      padding: theme.spacing(1),
    }),
  },
};

export default Menu;
